import DOMPurify from "dompurify";

/**
 * Sanitize HTML for safe rendering via dangerouslySetInnerHTML.
 * Strips scripts, event handlers, and dangerous tags while keeping
 * basic formatting (p, br, a, em, strong, ul, ol, li).
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ["p", "br", "a", "em", "strong", "b", "i", "ul", "ol", "li", "span"],
    ALLOWED_ATTR: ["href", "target", "rel"],
  });
}

/**
 * Strip all HTML tags and return plain text.
 */
export function stripHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, { ALLOWED_TAGS: [] });
}

/**
 * Decode HTML entities in plain text (e.g. &#39; → ', &amp; → &).
 * Safe for use in titles and other non-HTML contexts.
 */
let _textarea: HTMLTextAreaElement | null = null;
export function decodeEntities(text: string): string {
  if (!text || (!text.includes("&") && !text.includes("<"))) return text;
  if (!_textarea) _textarea = document.createElement("textarea");
  _textarea.innerHTML = DOMPurify.sanitize(text, { ALLOWED_TAGS: [] });
  return _textarea.value;
}
